/* eslint-disable react/no-unknown-property */
import {
  ActionIcon,
  Card,
  FontWeight,
  HStack,
  ICON_EYE_OUTLINE,
  ICON_FILE_DOCUMENT_ARROW_RIGHT_OUTLINE,
  Stack,
  Text,
  SimpleTable,
} from '@doveit/bricks';
import React from 'react';
import useIsDevice from '../../../hooks/use-is-device/useIsDevice';
import SimplePageLayout from '../../../layouts/simple-page-layout/SimplePageLayout';

const generableResources: {
  title: string,
  description: string,
  url: string,
}[] = [{
  title: 'Locandine immobili',
  description: 'Genera la locandina dei tuoi immobili o degli immobili degli agenti che gestisci.',
  url: '/marketing/generate/showcase',
},
{
  title: 'Brochure agenti',
  description: 'Genera la brochure di Agente Dove.it',
  url: '/marketing/generate/agent-brochure',
}];

const GenerateMaterialsPage: React.FC = () => {
  const isMobile = useIsDevice('mobile');

  return (
    <SimplePageLayout>
      <Card paddingSize="M">
        <Card.Header
          icon={{ path: ICON_FILE_DOCUMENT_ARROW_RIGHT_OUTLINE }}
          title="Genera materiali"
        />
        <Card.Content>
          <Text.Body>
            In questa sezione troverai gli strumenti per generare i materiali promozionali di Dove.it.
          </Text.Body>
        </Card.Content>
        <Card.Content>
          {!isMobile && (
            <SimpleTable>
              <SimpleTable.Body>
                {generableResources.map((resource) => (
                  <SimpleTable.Row key={resource.title}>
                    <SimpleTable.Cell>
                      <Text.Body fontWeight={FontWeight.REGULAR}>
                        {resource.title}
                      </Text.Body>
                    </SimpleTable.Cell>
                    <SimpleTable.Cell>
                      <Text.Body>
                        {resource.description}
                      </Text.Body>
                    </SimpleTable.Cell>
                    <SimpleTable.Cell>
                      <HStack>
                        <ActionIcon
                          aria-label={`Genera ${resource.title}`}
                          label={`Genera ${resource.title}`}
                          size="S"
                          icon={{ path: ICON_EYE_OUTLINE }}
                          href={resource.url}
                        />
                      </HStack>
                    </SimpleTable.Cell>
                  </SimpleTable.Row>
                ))}
              </SimpleTable.Body>
            </SimpleTable>
          )}

          {isMobile && (
            <Stack gap={150}>
              {generableResources.map((resource) => (
                <Card key={resource.title}>
                  <Card.Header
                    title={resource.title}
                    primaryActions={[
                      <ActionIcon
                        aria-label={`Genera ${resource.title}`}
                        label={`Genera ${resource.title}`}
                        size="S"
                        icon={{ path: ICON_EYE_OUTLINE }}
                        href={resource.url}
                      />,
                    ]}
                  />
                  <Card.Content>
                    <Text.Body>
                      {resource.description}
                    </Text.Body>
                  </Card.Content>
                </Card>
              ))}
            </Stack>
          )}
        </Card.Content>
      </Card>
    </SimplePageLayout>
  );
};

export default GenerateMaterialsPage;
